<div class="min-h-screen bg-navy-900">
  <router-outlet />
</div>
